import React from 'react';
import _ from 'lodash';

export default function FormControlFeedback({ errors, field }) {
  const validationError = _.find(errors, (err) => err.field === field);
  return (
    validationError?.message && <div className="mt-1 alert alert-danger small">{validationError.message}</div>
  );
}
